import { useAuth0 } from "@auth0/auth0-react";
import { Typography } from "antd";
import "./UserHeaderProfile.css";

export const UserHeaderProfile: React.FC = () => {
  const { user } = useAuth0();
  const isSameUser = user?.name === user?.email;
  const userLabel = isSameUser ? user?.email : `${user?.name} <${user?.email}>`;
  return (
    <div className="UserHeaderProfile" title={userLabel}>
      <img className="UserHeaderProfileAvatar" src={user?.picture} alt={user?.name || ""} />
      <div className="UserHeaderProfileLabel">
        {isSameUser ? undefined : (
          <Typography.Text data-field="user.name" strong>
            {user?.name}
          </Typography.Text>
        )}
        <Typography.Text data-field="user.email">{user?.email}</Typography.Text>
      </div>
    </div>
  );
};
